import { render, staticRenderFns } from "./AudienceSearch.vue?vue&type=template&id=d5a2779e&scoped=true"
import script from "./AudienceSearch.vue?vue&type=script&lang=js"
export * from "./AudienceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a2779e",
  null
  
)

export default component.exports